import { useEffect } from 'react';
import { Platform, useWindowDimensions } from 'react-native';
import Animated, { Easing, ReduceMotion, useAnimatedProps, useSharedValue, withTiming } from 'react-native-reanimated';
import Svg, { Rect } from 'react-native-svg';

import { getLightRatingColor } from '@/utils/getLightRatingColor';

interface ScrenStateProps {
  lightRating: number;
  totalPages: number;
  currentPage: number;
}
const AnimatedRect = Animated.createAnimatedComponent(Rect);

const ScreenState = ({ lightRating, totalPages, currentPage }: ScrenStateProps) => {
  const { width } = useWindowDimensions();

  const pillWidth = width >= 1024 ? 32 : width >= 768 ? 20 : width >= 375 ? 16 : 12;

  const animated = Platform.OS === 'ios';
  const fill = useSharedValue('#E6E6E6');

  useEffect(() => {
    fill.value = withTiming(getLightRatingColor(lightRating), {
      duration: 750,
      easing: Easing.linear,
      reduceMotion: ReduceMotion.System
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lightRating]);

  const animatedProps = useAnimatedProps(() => ({
    fill: fill.value
  }));

  const state = new Array(totalPages);

  for (let i = 0; i < totalPages; i++) {
    state.push(
      <Svg width={pillWidth} height={10} key={i}>
        {animated ? (
          <AnimatedRect
            width={pillWidth}
            height={10}
            rx={5}
            ry={5}
            {...(i < currentPage ? { animatedProps } : undefined)}
            fill={i < currentPage ? getLightRatingColor(lightRating) : '#E6E6E6'}
          />
        ) : (
          <Rect
            width={pillWidth}
            height={10}
            rx={5}
            ry={5}
            fill={i < currentPage ? getLightRatingColor(lightRating) : '#E6E6E6'}
          />
        )}
      </Svg>
    );
  }

  return state;
};

export default ScreenState;
